<template>
  <mds-button v-if="icon" variation="icon-only" :icon="icon" type="button" class="baseGridIcon"
    @click="$emit('click', $event)"
    @mouseover="$emit('showToolTip', $event, formattedValue)"
    @mouseleave="$emit('hideToolTip')"
  >
  </mds-button>
</template>
<script>
export default {
  name: 'baseGridIcon',
  props: ['icon', 'tooltipMessage'],
  computed: {
    formattedValue() {
      if (Array.isArray(this.tooltipMessage)) {
        return this.tooltipMessage;
      }
      return [this.tooltipMessage];
    },
  },
};
</script>
